import { Link } from 'react-router-dom';
import { dramas, tags } from '@/mocks/dramas';

const stats = [
  { value: String(dramas.length * 6), label: '收录剧集' },
  { value: '1,280', label: '主创档案' },
  { value: '96%', label: '内容覆盖率' },
  { value: '每日', label: '资料更新' },
];

export default function HomeIntro() {
  return (
    <section className="w-full px-4 md:px-10 py-12 md:py-16 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-1.5 text-[11px] tracking-[0.18em] uppercase text-primary-600 mb-3">
            <span className="w-4 h-px bg-primary-400"></span>
            About the Collection
          </span>
          <h2 className="font-heading text-2xl md:text-[32px] leading-snug font-semibold text-foreground-950 mb-4">
            用更从容的方式，
            <br className="hidden md:block" />
            读一个关于人的故事
          </h2>
          <p className="text-sm leading-7 text-foreground-600 mb-4">
            伦理题材之所以动人，是因为它从不给人一个轻松的答案。家庭里的沉默、婚姻中的退让、代际之间的误解，这些看似日常的处境，往往藏着最难的取舍。我们希望把这些作品整理得更清楚一些：谁写的、谁演的、故事从哪里开始、又停在哪里。
          </p>
          <p className="text-sm leading-7 text-foreground-600 mb-6">
            站内所有剧集信息、评分与热度均为演示内容，仅用于浏览与阅读。影视作品的观看请通过正规授权渠道进行。
          </p>
          <div className="flex flex-wrap gap-1.5">
            {tags.slice(0, 12).map((tag) => (
              <Link
                key={tag}
                to={`/search?q=${encodeURIComponent(tag)}`}
                className="h-7 px-3 rounded-full bg-secondary-100 text-secondary-900 text-[11px] flex items-center hover:bg-secondary-200 transition-colors"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>
        <div className="lg:col-span-5 w-full">
          <div className="rounded-lg border border-background-200 overflow-hidden">
            <div className="grid grid-cols-2">
              {stats.map((s, idx) => (
                <div
                  key={s.label}
                  className={`p-5 md:p-6 ${idx % 2 === 0 ? 'border-r border-background-200' : ''} ${
                    idx < 2 ? 'border-b border-background-200' : ''
                  } ${idx === 0 ? 'bg-accent-50' : 'bg-background-100/60'}`}
                >
                  <p className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
                    {s.value}
                  </p>
                  <p className="text-xs text-foreground-600 mt-1.5">{s.label}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="h-12 px-5 flex items-center justify-between bg-primary-950 text-background-100 text-xs md:text-sm hover:bg-primary-900 transition-colors"
            >
              了解平台定位与内容声明
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}